import React, { memo } from 'react';

import { Card, Skeleton, Space } from 'antd';

const ReviewCardSkeleton: React.FC = () => {
  return (
    <div className="review-card review-card--skeleton">
      <Card
        className="card__content"
        style={{
          width: '100%',
          borderRadius: 12,
        }}
        bordered={false}
        bodyStyle={{ padding: 0 }}
      >
        <Space size={0} direction="vertical" style={{ width: '100%' }}>
          <Space size={0} direction="vertical" style={{ width: '100%' }}>
            <Skeleton
              avatar={{ shape: 'circle', size: 40 }}
              title={{
                width: '100%',
                style: { margin: 0, marginBottom: 8, maxWidth: 150 },
              }}
              paragraph={{
                rows: 1,
                style: { margin: 0, marginBottom: 0, maxWidth: 200 },
              }}
              round
              active
              style={{
                marginBottom: 24,
              }}
            />

            <Skeleton
              active
              round
              title={false}
              paragraph={{ rows: 2, style: { margin: 0, marginBottom: 24 } }}
            />
          </Space>

          <Skeleton.Button
            active
            shape="round"
            size="small"
            block
            style={{ maxWidth: 400 }}
          />
        </Space>
      </Card>
    </div>
  );
};

export default memo(ReviewCardSkeleton);
